<template>
    <div class="flats-crm-viewing-history-page" v-if="dataItems != null">
        <div class="container">
            <div class="section-title" v-if="flatsPage != null">
                <h2>{{ flatsPage.flats_cards_info.flat_history_page_title}}</h2>
            </div>
            <!-- {{this.dataItems}} -->
            <div class="flats-items">
                <flatsItemsList :flatsArr="dataItems" class="history-page-items"></flatsItemsList>
            </div>
        </div>
        <formPage class="form-flat-viewed-history"></formPage>
    </div>
</template>

<script>
	import flatsItemsList from '@/components/flats-crm/flats-crm-items-viewed-list.vue'
	import formPage from '@/components/forms/form-page.vue';	
    import {mapGetters} from 'vuex'
    export default {
        name: 'sale-CRM-viewed-flats',
        props: ['cardData'],
        components: {
            flatsItemsList,
            formPage,
        },
        data () {
            return {
                dataItems: null,
                dataResp: {
                    "apartmentIds": null,
                }
            }
        },
        computed: mapGetters({
            flatsPage: 'loadFlatsPage',
        }),
        methods: {
            getViewedFlats() {
                // console.log(this.$route.params.id, 'ID CADD ROUTER')
                var id = this.$route.params.id;
                var exist = localStorage.getItem('viewed_flats');
                exist = exist ? exist.split(',') : [];

                // console.log(exist, 'FLATS VIEWD');

                this.dataResp.apartmentIds = exist.slice(-100);
               
                if (this.dataResp.apartmentIds.length > 0) {
                    axios.post(window.CRMProxy + '/v1/apartments', this.dataResp).then(async (response) => {
                        if (response.data.data.length != 0) {
                            this.shortArray(response.data.data)
                        }
                    }).catch(() => {
                        this.dataItems = null;
                    });
                } else {
                    this.dataItems = null;
                    this.$router.push('/flats');
                }
                
            },
            shortArray(items) {
                items.sort(this.sortFunc);
                // console.log(items, 'items')
                this.dataItems = items.reverse();
            },
            sortFunc(a, b) {
                var sortingArr = this.dataResp.apartmentIds;
                return sortingArr.indexOf(a.id) - sortingArr.indexOf(b.id);
            },
        },
        beforeRouteEnter (to, from, next) {
            next(vm => {
                vm.getViewedFlats();
                vm.$parent.$refs.topProgress.done();
                vm.$store.commit('removePageLoaderImg');
            });
        },
        beforeCreate() {
            document.body.dataset.page = 'flats-viewing-history';
        },
        created () {
            this.getViewedFlats();
        },
        mounted () {
        }
    }
</script>

<style lang="scss">
    @import '@/styles/components/flats-crm/flats-crm-viewing-history.scss';
    // @import '@/styles/components/flats-crm/respond/flats-crm-viewed-flats-respond.scss';
    // @import '@/styles/components/flats-crm/respond/flats-crm-btns-respond.scss';
    // @import '@/styles/respond/sales/sales-land-partials/land-flats-respond.scss';
    // @import '@/styles/respond/sales/respond-sale-item.scss';
</style>